module.exports = __webpack_public_path__ + "assets/img/i8.92c21e2e.png";